import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	getConfirmedOrders,
	getConfirmedOrdersLoader,
	getOrderDetailsCombined,
	getOrderDetailsCombinedLoader,
} from 'redux/reducers/orders/selectors';
import { OrderVatCorrectionsItem } from './OrderVatCorrectionsItem';

export const OrderVatCorrections: FC = () => {
	const orders = useSelector(getConfirmedOrders);
	const ordersIsLoading = useSelector(getConfirmedOrdersLoader);
	const orderDetailsCombined = useSelector(getOrderDetailsCombined);
	const orderDetailsCombinedIsLoading = useSelector(getOrderDetailsCombinedLoader);
	const orderCorrections = orderDetailsCombined?.orderCorrections;

	return (
		<div>
			{!!orders?.data?.length &&
				!!orderCorrections?.length &&
				!ordersIsLoading &&
				!orderDetailsCombinedIsLoading && (
					<Card
						sx={{
							mb: 2,
							'&': {
								borderRadius: '12px',
							},
						}}
					>
						<CardContent>
							<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<Typography sx={{ fontSize: 14 }} color="primary" gutterBottom>
									VAT Corrections
								</Typography>
							</Box>

							{orderCorrections.map((item) => (
								<OrderVatCorrectionsItem key={item.id} varCorrectionsItem={item} detalization />
							))}
						</CardContent>
					</Card>
				)}
			{(ordersIsLoading || orderDetailsCombinedIsLoading) && (
				<Skeleton variant="rectangular" height="300px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
